<template>
	<div v-loading.fullscreen.lock="loading" class="dynamicDe">
		<div class="dynamicDeCon">
			<div class="left">
				<div class="center">
					<div class="name">
						{{detail.title}}
					</div>
					<div class="time">
						{{detail.created_at}}
					</div>
				</div>
				<div class="bottom">
					<div v-html="detail.content">
						
					</div>
				</div>
			</div>
			<div class="right">
				<downCode></downCode>
			</div>
		</div>
		
	</div>
</template>

<script>
	import downCode from '@/components/downCode.vue'
	export default {
		name:'dynamicDe',
		components: {
			downCode
		},
		data() {
			return {
				id:'',
				detail:'',
				loading:false
			}
		},
		created() {
			this.id=this.$route.query.id
			this.getDetail()
		},
		methods: {
			getDetail(){
				this.loading = true
				this.$axios.get('/api/client/Common/getAnnouncementsDetails',{params:{id:this.id}}).then(res => {
					this.loading = false
					if (res.code == 200) {
						this.detail=res.data
					} else {
						this.$eltips(res.msg, 'error')
					}
				})
			}
		}
	}
</script>

<style lang="scss">
	.dynamicDe{
		position: relative;
		padding: 38px 0;
		display: flex;
		justify-content: center;
		.dynamicDeCon{
			display: flex;
			margin: 0 auto;
			width: 1200px;
			position: relative;
			z-index: 2;
			.left{
				flex: 1;
				background-color: #FFF;
				border-radius: 16px;
				padding: 25px 38px 33px;
				margin-right: 16px;
				.center{
					color: #151515;
					margin-bottom: 32px;
					.name{
						font-size: 32px;
						margin-bottom: 24px;
						font-weight: bold;
					}
					.time{
						font-size: 16px;
						
					}
				}
				.bottom{
					color: #151515;
					font-size: 18px;
					img{
						max-width: 100%;
						height: auto;
						display: block;
						margin: 0 auto;
					}
				}
			}
		
		    .right{
				
			}
		}
	}
</style>